<template>
    <modal name="update_pricelist" height="auto" scrollable adaptive @before-open="beforeOpen">
        <app-card :title="$t('Update price list')">
            <validation-observer v-slot="{ validate }" slim>
                <form @submit.prevent="update(validate)">
                    <app-multi-lang-input
                        id="name"
                        v-model="form.name"
                        name="name"
                        rules="required"
                        :langs="locales && Object.keys(locales)">
                        <template #label> {{ $t('Name') }}* </template>
                    </app-multi-lang-input>
                    <div class="row">
                        <div class="col">
                            <app-day-month-input v-model="form.start" day_id="start_day" month_id="start_month">
                                <template #label> {{ $t('Start') }}* </template>
                            </app-day-month-input>
                        </div>
                        <div class="col">
                            <app-day-month-input v-model="form.end" day_id="end_day" month_id="end_month">
                                <template #label> {{ $t('End') }}* </template>
                            </app-day-month-input>
                        </div>
                    </div>
                    <hr />
                    <h5>
                        {{ $t('Day ranges') }}
                        <app-button nativeType="button" class="float-right" @click="newRange" small>
                            {{ $t('New range') }}
                        </app-button>
                    </h5>
                    <div class="clearfix"></div>
                    <template v-for="(range, i) in form.ranges">
                        <div class="input-group input-group-sm mb-3" :key="i">
                            <div class="input-group-prepend">
                                <span class="input-group-text">{{ $t('Min') }}</span>
                            </div>
                            <input type="number"
                                   name="min"
                                   :id="`min_${i}`"
                                   :max="range.max"
                                   min="0"
                                   class="form-control form-control-sm custom-gray-input-bg"
                                   v-model="range.min"/>
                            <div class="input-group-prepend">
                                <span class="input-group-text">{{ $t('Max') }}</span>
                            </div>
                            <input type="number"
                                   name="max"
                                   :id="`max_${i}`"
                                   :min="range.min"
                                   class="form-control form-control-sm custom-gray-input-bg"
                                   v-model="range.max"/>
                            <div class="input-group-append pointer" @click="destroyRange(i)">
                                <span class="input-group-text text-white bg-danger">X</span>
                            </div>
                        </div>
                    </template>
                    <div class="form-group row">
                        <div class="col-md-7 offset-md-3 d-flex">
                            <app-button :loading="loading">
                                {{ $t('Update') }}
                            </app-button>
                            <app-button class="ml-2" type="outline-warning" native-type="button" @click="hide">
                                {{ $t('Cancel') }}
                            </app-button>
                        </div>
                    </div>
                </form>
            </validation-observer>
        </app-card>
    </modal>
</template>

<script>
import PricelistService from '@services/pricelist.service';
import { mapGetters } from 'vuex';

export default {
    data() {
        return {
            form: {
                ranges: []
            },
            loading: false,
            pricelist_id: null
        };
    },
    computed: {
        ...mapGetters(['locales'])
    },
    methods: {
        newRange() {
            this.form.ranges.push({ pricelist_id: this.pricelist_id, min: null, max: null });
        },
        destroyRange(index) {
            this.form.ranges.splice(index, 1);
        },
        update(validate) {
            validate().then(valid => {
                if (valid) {
                    this.loading = true;
                    PricelistService.update(this.pricelist_id, this.form).then(res => {
                        this.$toastr.s(this.$t('Updated'));
                        this.loading = false;
                        this.hide();
                        this.$emit('setPricelist', res);
                    });
                }
            });
        },
        beforeOpen(event) {
            const pricelist = event.params.pricelist;
            if (pricelist) {
                this.pricelist_id = pricelist.id;
                this.form.name = Object.assign({}, pricelist.name);
                this.form.start = pricelist.start;
                this.form.end = pricelist.end;
                this.form.ranges = Object.assign([], pricelist.ranges);
            }
        },
        hide() {
            this.$modal.hide('update_pricelist');
        }
    }
};
</script>
